export default {
  "root": "_root_ks209_1",
  "--loading": "_--loading_ks209_1",
  "--highlighted": "_--highlighted_ks209_1",
  "--disabled": "_--disabled_ks209_1",
  "text": "_text_ks209_1",
  "icon": "_icon_ks209_1",
  "--icon-position-end": "_--icon-position-end_ks209_1",
  "loader": "_loader_ks209_1",
  "--icon-only": "_--icon-only_ks209_1",
  "--rounded": "_--rounded_ks209_1",
  "--size-small": "_--size-small_ks209_1",
  "--size-medium": "_--size-medium_ks209_1",
  "--size-large": "_--size-large_ks209_1",
  "--size-xlarge": "_--size-xlarge_ks209_1",
  "--full-width": "_--full-width_ks209_1",
  "--variant-solid": "_--variant-solid_ks209_1",
  "--color-neutral": "_--color-neutral_ks209_1",
  "--color-primary": "_--color-primary_ks209_1",
  "--color-critical": "_--color-critical_ks209_1",
  "--color-positive": "_--color-positive_ks209_1",
  "--color-media": "_--color-media_ks209_1",
  "--variant-faded": "_--variant-faded_ks209_1",
  "--color-inherit": "_--color-inherit_ks209_1",
  "--variant-outline": "_--variant-outline_ks209_1",
  "--variant-ghost": "_--variant-ghost_ks209_1",
  "--elevated": "_--elevated_ks209_1",
  "group": "_group_ks209_1",
  "aligner": "_aligner_ks209_1",
  "--size-small--m": "_--size-small--m_ks209_1",
  "--size-medium--m": "_--size-medium--m_ks209_1",
  "--size-large--m": "_--size-large--m_ks209_1",
  "--size-xlarge--m": "_--size-xlarge--m_ks209_1",
  "--full-width-true--m": "_--full-width-true--m_ks209_1",
  "--full-width-false--m": "_--full-width-false--m_ks209_1",
  "--size-small--l": "_--size-small--l_ks209_1",
  "--size-medium--l": "_--size-medium--l_ks209_1",
  "--size-large--l": "_--size-large--l_ks209_1",
  "--size-xlarge--l": "_--size-xlarge--l_ks209_1",
  "--full-width-true--l": "_--full-width-true--l_ks209_1",
  "--full-width-false--l": "_--full-width-false--l_ks209_1",
  "--size-small--xl": "_--size-small--xl_ks209_1",
  "--size-medium--xl": "_--size-medium--xl_ks209_1",
  "--size-large--xl": "_--size-large--xl_ks209_1",
  "--size-xlarge--xl": "_--size-xlarge--xl_ks209_1",
  "--full-width-true--xl": "_--full-width-true--xl_ks209_1",
  "--full-width-false--xl": "_--full-width-false--xl_ks209_1"
};import "ni:sha-256;TzHByqMpEtAyuhmTbbzUrYIKTvPJjJ1CYkhNNuKvKwo";